var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreatDetected24DetectionsError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9991 20.7724C16.7554 20.7724 20.6111 16.9167 20.6111 12.1604C20.6111 7.40415 16.7554 3.54843 11.9991 3.54843C7.24287 3.54843 3.38715 7.40415 3.38715 12.1604C3.38715 16.9167 7.24287 20.7724 11.9991 20.7724ZM11.9991 22.0666C17.4702 22.0666 21.9053 17.6314 21.9053 12.1604C21.9053 6.68942 17.4702 2.25429 11.9991 2.25429C6.52814 2.25429 2.09301 6.68942 2.09301 12.1604C2.09301 17.6314 6.52814 22.0666 11.9991 22.0666Z",
    fill: "#B71D18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9982 17.9604C15.2013 17.9604 17.7979 15.3638 17.7979 12.1607C17.7979 8.95764 15.2013 6.36103 11.9982 6.36103C8.7951 6.36103 6.19849 8.95764 6.19849 12.1607C6.19849 15.3638 8.7951 17.9604 11.9982 17.9604ZM11.9982 19.2546C15.916 19.2546 19.092 16.0785 19.092 12.1607C19.092 8.24291 15.916 5.06689 11.9982 5.06689C8.08036 5.06689 4.90435 8.24291 4.90435 12.1607C4.90435 16.0785 8.08036 19.2546 11.9982 19.2546Z",
    fill: "#B71D18"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.27309 12.1117C7.27309 12.469 6.98339 12.7588 6.62602 12.7588H1.68223C1.32486 12.7588 1.03516 12.469 1.03516 12.1117C1.03516 11.7543 1.32486 11.4646 1.68223 11.4646H6.62602C6.98339 11.4646 7.27309 11.7543 7.27309 12.1117Z",
    fill: "#B71D18"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 7.38344C12.3587 7.38344 12.6484 7.09374 12.6484 6.73637V1.79258C12.6484 1.43521 12.3587 1.14551 12.0013 1.14551C11.644 1.14551 11.3543 1.43521 11.3543 1.79258V6.73637C11.3543 7.09374 11.644 7.38344 12.0013 7.38344Z",
    fill: "#B71D18"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9677 12.1117C22.9677 12.469 22.678 12.7588 22.3206 12.7588H17.3768C17.0195 12.7588 16.7297 12.469 16.7297 12.1117C16.7297 11.7543 17.0195 11.4646 17.3768 11.4646H22.3206C22.678 11.4646 22.9677 11.7543 22.9677 12.1117Z",
    fill: "#B71D18"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0013 23.1455C11.644 23.1455 11.3543 22.8558 11.3543 22.4984V17.5546C11.3543 17.1973 11.644 16.9076 12.0013 16.9076C12.3587 16.9076 12.6484 17.1973 12.6484 17.5546V22.4984C12.6484 22.8558 12.3587 23.1455 12.0013 23.1455Z",
    fill: "#B71D18"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatDetected24DetectionsError);
export default __webpack_public_path__ + "static/media/threat-detected-24-detections-error.1a214b627164b0e1c3cf2e8d35d3ef0d.svg";
export { ForwardRef as ReactComponent };